var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u_prf pt-2 pb-2" },
    [
      _c("b-overlay", { attrs: { show: _vm.module.is_load, rounded: "sm" } }, [
        _c(
          "div",
          { staticClass: "user_tabs" },
          [
            _c(
              "b-tabs",
              { staticClass: "nav-tabs-clean", attrs: { "content-class": "" } },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c(
                  "b-tab",
                  {
                    key: index,
                    attrs: {
                      disabled: tab.disabled,
                      title: _vm.get_tab_title(tab),
                      active: tab.is_active,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.set_active(index)
                      },
                    },
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c(
                        "div",
                        { staticClass: "fs-lg px-4 pt-2" },
                        [
                          _c("i", {
                            staticClass: "fal text-primary pr-2",
                            class: tab.icon,
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.get_tab_title(tab)) +
                              "\n                                "
                          ),
                          tab.is_load
                            ? _c("b-spinner", {
                                attrs: { type: "grow", small: "" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(tab.index, {
                      tag: "component",
                      attrs: { user: _vm.user },
                    }),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }